import styled from 'styled-components';

export const HeroGrid = styled.div`
  //Start with the grid: 3x3
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  //grid-gap goes here if we need it
`;

export const RootsPageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const RootsMain = styled.main`
  // Probably have to fix this with a media query: phone size is a different setup
  grid-column: 1;
  grid-row: 1 / 2;
`;

export const RootsImage = styled.div`
  // Media query
  grid-column: 2;
  grid-row: 1 / 2;
`;

export const StonesPageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 6px;
`;

export const ItemsPageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 6px;
`;
